// import DeptWiseCompliance from "./DeptWiseComp";
// import PriorityWiseCompliance from "./PriorityWiseComp";
import { Row } from "@neumetric/blueprint-lib/components";
import {
  RemediationDeptWiseDonut,
  RemediationDeptWiseStatsTable,
  RemediationDeptWiseBarChart,
} from "./DeptWiseComponents";
import {
  RemediationPriorityWiseDonut,
  RemediationPriorityWiseStatsTable,
  RemediationPriorityWiseBarChart,
} from "./PriorityWiseComponents";

export function RemediatorStats(props) {
  const { dateRange, dateRangeList, mode } = props;
  const dateRangeEnums = dateRangeList || [];
  const dateRangeLabel = dateRangeEnums.find(
    (obj) => obj.id === dateRange.id
  )?.label;
  return (
    <div className="o-auto h-100">
      {(mode === "fusion" || mode === "export_everything") && (
        <Row
          style={{
            gap: "20px",
          }}
          className="w-100 flex-wrap"
          align="start"
        >
          <RemediationDeptWiseDonut
            dateRangeLabel={dateRangeLabel}
            mode={mode}
          />
          <RemediationPriorityWiseDonut
            dateRangeLabel={dateRangeLabel}
            mode={mode}
          />
        </Row>
      )}
      {(mode === "full" || mode === "export_everything") && (
        <Row
          style={{
            gap: "20px",
          }}
          className="w-100 flex-wrap"
          align="start"
        >
          <RemediationDeptWiseStatsTable dateRangeLabel={dateRangeLabel} />
          <RemediationDeptWiseBarChart dateRangeLabel={dateRangeLabel} />
        </Row>
      )}
      <Row
        style={{
          gap: "20px",
        }}
        className="w-100 flex-wrap mt-36"
        align="start"
      >
        {(mode === "full" || mode === "export_everything") && (
          <RemediationPriorityWiseStatsTable dateRangeLabel={dateRangeLabel} />
        )}
        <RemediationPriorityWiseBarChart mode={mode} />
      </Row>
      {mode !== "fusion" && (
        <div style={{ paddingTop: "100px" }}>
          <hr className="nm-hr nm-hr--center" />
        </div>
      )}
    </div>
  );
}
